import { render, staticRenderFns } from "./VEmployerCompanySummary.vue?vue&type=template&id=77650b4b&lang=pug"
import script from "./VEmployerCompanySummary.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompanySummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports